import { IFilter } from '@dash/filter';
import { formatPropName } from '../components/logs/logMeta';
import { t } from '../i18n';

export const translateFilterOptions = (filters: IFilter[], translationPrefix: string) => {
  if (!filters || !filters.length) {
    return filters;
  }

  filters.forEach(filter => {
    if (filter.filterOptions.length) {
      filter.filterOptions = filter.filterOptions.map(filterOption => ({
        ...filterOption,
        name: t(`${translationPrefix}.${filter.name}.${filterOption.id}`, {}, formatPropName(filterOption.name), false),
      }));
    }
  });

  return filters;
};
